// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { LoincCodeResponse } from './loinc-code-response';

// @ts-ignore
import { ProviderResponse } from './provider-response';

/** See com.rev360.pms.api.controller.laborder.LabOrderListResponse */
/* istanbul ignore next */
@GandalfModel
export class LabOrderListResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	endDate!: Date | null;

	@GandalfProperty({ designType: Number })
	fileCount!: number | null;

	@GandalfProperty({ designType: Boolean })
	hasInterpretation!: boolean | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	labName!: string | null;

	@GandalfProperty({ designType: LoincCodeResponse })
	order!: LoincCodeResponse | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	orderDate!: Date | null;

	@GandalfProperty({ designType: ProviderResponse })
	orderedBy!: ProviderResponse | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	performedDate!: Date | null;

	@GandalfProperty({ designType: String })
	result!: string | null;

	@GandalfProperty({ designType: Number })
	resultNum!: number | null;

	@GandalfConstantDecorator(constants.LabOrderResultType)
	@GandalfProperty({ designType: constants.LabOrderResultType })
	resultType!: constants.LabOrderResultType | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.LabOrderStatus)
	@GandalfProperty({ designType: constants.LabOrderStatus })
	status!: constants.LabOrderStatus | null;

}
